import React from 'react';
import { Flex, Box, Text, IconButton, Heading } from '@chakra-ui/react';

const InfoCard = ({ 
  heading,
  icon,
  children, 
  headingFontSize = "md", 
  headingFontWeight = "500", 
  headingColor = "gray",
  iconSize = "md",
  iconColor = "white",
  ...props 
}) => {
  return (
    <Box
      bg="white"
      boxShadow="md"
      borderRadius="lg"
      p={4}
      {...props}
    >
      {/* Header with title and icon button */}
      <Flex justify="space-between" align="center" mb={5}>
        <Heading fontSize={headingFontSize} fontWeight={headingFontWeight} color={headingColor}>
        {heading}
        </Heading>
        <IconButton
          icon={icon}
          size={iconSize}
          bg="linear-gradient(134.23deg, #071D54 14.41%, #1E3A8A 85.58%)"
          color={iconColor}
          borderRadius="12px"
          cursor="pointer"
          _hover={{
            bg: "linear-gradient(134.23deg, #071D54 14.41%, #1E3A8A 85.58%)",
          }}
        />
      </Flex>

      {/* Children content (e.g., table) */}
      <Box>
        {children}
      </Box>
    </Box>
  );
};

export default InfoCard;
